import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "record"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
    key: 1,
    class: "grey"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 2,
    class: "black up-letter"
};
import UTooltip from "@/components/uikit/uComponents/UTooltip.vue";
import { computed } from "vue";
import { useFilters } from "@/composables/useFilters";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UListItem',
    props: {
        type: {},
        styleType: {},
        label: {},
        value: {},
        color: {},
        tooltip: {},
        token: {},
        visible: { type: Boolean, default: true },
        url: {}
    },
    setup(__props) {
        const { shortAddress } = useFilters();
        const props = __props;
        const textClasses = computed(() => ({
            grey: props.styleType == "grey",
            green: props.styleType == "green"
        }));
        const labelClasses = computed(() => ({
            grey: props.styleType == "grey" || props.styleType == "greyLabel",
            green: props.styleType == "green"
        }));
        const getShortAddressLowercase = (address) => {
            return shortAddress(address).toLowerCase();
        };
        const getBooleanValue = (value) => {
            return value == "true" ? "Yes" : "No";
        };
        const booleanIcon = props.value == "true"
            ? "/img/project-card/success-mark.svg"
            : "/img/project-card/no-mark.svg";
        return (_ctx, _cache) => {
            const _component_UDecimal = _resolveComponent("UDecimal");
            const _component_UIcon = _resolveComponent("UIcon");
            return (props.visible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass(labelClasses.value)
                    }, _toDisplayString(__props.label), 3),
                    _createElementVNode("div", {
                        class: _normalizeClass(["sep", { 'sep-green': __props.styleType == 'green' }])
                    }, null, 2),
                    _createElementVNode("div", {
                        class: _normalizeClass([textClasses.value, "text"])
                    }, [
                        (__props.type == 'address')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (__props.value)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "green link",
                                        href: __props.url
                                    }, _toDisplayString(getShortAddressLowercase(__props.value)), 9, _hoisted_2))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_3, " None "))
                            ], 64))
                            : (__props.type == 'decimals')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (props.token?.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                            _createVNode(_component_UDecimal, _normalizeProps(_guardReactiveProps(props.token)), null, 16)
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_5, " None "))
                                ], 64))
                                : (__props.type == 'boolean')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                        _createTextVNode(_toDisplayString(getBooleanValue(__props.value)) + " ", 1),
                                        _createVNode(_component_UIcon, { icon: _unref(booleanIcon) }, null, 8, ["icon"])
                                    ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode(_toDisplayString(__props.value), 1)
                                    ], 64)),
                        (__props.tooltip)
                            ? (_openBlock(), _createBlock(UTooltip, {
                                key: 4,
                                tooltip: __props.tooltip
                            }, null, 8, ["tooltip"]))
                            : _createCommentVNode("", true)
                    ], 2)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
